export enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

export interface ILogger {
  trace(...args: any[]): ILogger;

  debug(...args: any[]): ILogger;

  info(...args: any[]): ILogger;

  warn(...args: any[]): ILogger;

  error(...args: any[]): ILogger;

  fatal(...args: any[]): ILogger;

  log(level: LogLevel, ...args: any[]): ILogger;
}
